import PageTitle from '../blog/PageTitle';
import SectionContainer from '../blog/SectionContainer';
// import { CommonSEO } from "../blog/SEO";
import formatDate from '../../lib/utils/formatDate';
import ScrollTopAndComment from '../blog/ScrollTopAndComment';

export default function PostLayout({ frontMatter, children }) {
  const { date, title, summary, images } = frontMatter;

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white">
      <div className=" antialiased px-4 py-10 max-w-3xl mx-auto sm:px-6 sm:py-12 lg:max-w-4xl lg:py-16 lg:px-8 xl:max-w-6xl">
        <article>
          <div className="space-y-10 sm:space-y-12 lg:space-y-20 xl:space-y-24">
            {/* / */}
            <div className="prose prose-sm sm:prose lg:prose-lg xl:prose-xl mx-auto sm:prose-indigo">
              {/* / */}
              <div className="space-y-10 sm:space-y-0 flex items-center ">
                <h1 className="mx-auto">{title}</h1>
              </div>
              {children}
            </div>

            {/* / */}
          </div>
        </article>
      </div>
    </div>
  );
}
